import React from 'react';
import { StatError } from '../../../CommonComponents/OPL/Stat/Stat.error';
import { StatLoading } from '../../../CommonComponents/OPL/Stat/Stat.loading';
import { MarketValueContent } from './components/MarketValueContent/MarketValueContent';
import { useMarketValue } from './useMarketValue';

export const MarketValue: React.FC = () => {
  const { isFetching, isError, refetch, data } = useMarketValue();

  if (isFetching) {
    return <StatLoading />;
  }

  if (isError) {
    return <StatError onRetry={refetch} />;
  }

  if (!data) {
    return null;
  }

  const { label, value } = data;

  return <MarketValueContent label={label} value={value} />;
};
